import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import renderField from '../../Inputs';
import Progress from '../../Progress';

const required = value => (value || typeof value === 'number' ? undefined : 'Required');
const number = value => (value && isNaN(Number(value)) ? 'Must be a number' : undefined);

const parsers = {
  number: (value) => {
    let result;
    if (new RegExp(/^\d*$/g).test(value) && !(value.indexOf('.') > -1) && value.length > 3) {
      result = parseInt(value.substring(0, 3), 10) <= 999 ? value.substring(0, 3) : '';
    }

    if (value) {
      return new RegExp(/^([0-9]|[1-9][0-9]|[1-9][0-9][0-9])$/g).test(value) ? value : result;
    }
    return '';
  },
};

const inputTypes = [window.HTMLInputElement, window.HTMLSelectElement, window.HTMLTextAreaElement];

const triggerInputChange = (node, value = 0) => {
  if (inputTypes.indexOf(node.__proto__.constructor) > -1) {
    const setValue = Object.getOwnPropertyDescriptor(node.__proto__, 'value').set;

    const event = document.createEvent('Event');
    event.initEvent('input', true, true);
    // not support on ie
    // const event = new Event('input', { bubbles: true });

    setValue.call(node, value);
    node.dispatchEvent(event);
  }
};

class Smoking extends React.PureComponent {
  state = {
    smokingAmount: 0,
  };

  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
    triggerInputChange(this.input);
  }

  increHandler = (e) => {
    e.preventDefault();
    const inputVal = parseInt(this.input.value, 10);

    if (!isNaN(inputVal) && parsers.number(inputVal.toString())) {
      triggerInputChange(this.input, inputVal + 1);
    } else {
      triggerInputChange(this.input, 1);
    }
  }

  decreHandler = (e) => {
    e.preventDefault();
    const inputVal = parseInt(this.input.value, 10);

    if (!isNaN(inputVal) && parsers.number(inputVal.toString())) {
      triggerInputChange(this.input, inputVal - 1);
    } else {
      triggerInputChange(this.input, 0);
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <Row classes="compaign-page smoking-less" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <div className="campaign-bg red">
          <svg width="800" height="800" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-191.538 1736.18s948.537-475.5 1124.563-1274.192c176.025-798.691-159.68-1553.548-159.68-1553.548S-559.786 393.866-191.538 1736.18z" className="svg_bg_1" />
            <path d="M-453.085 1609.5s686.975 166.29 1120.563-167.95c433.592-334.23 585.632-865.687 585.632-865.687S-64.2127 762.802-453.085 1609.5z" className="svg_bg_2" />
            <path d="M-453.235 1609.39S150.648 1239.78 223.1 697.465C295.553 155.149 27.7053-326.192 27.7053-326.192S-775.018 737.63-453.235 1609.39z" className="svg_bg_3" />
            <path d="M706.354-437.052C250.513-42.8394-467.631 720.706-453.084 1608.95c23.479-11.88 950.315-485.4 1124.109-1273.962 59.894-271.7576 60.543-538.441 35.329-772.04z" className="svg_bg_4" />
          </svg>
        </div>
        <Progress step="smoking" />
        <Paragraph center>
          <img className="section-logo" src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="50" height="50" />
        </Paragraph>

        <form onSubmit={handleSubmit} className="form-campaign">
          <Heading classes="header-text campaign-header-text" center>How many cigarettes do you smoke per day?</Heading>
          <Paragraph classes="desc-text" center>E-cigs don{"'"}t count. <img src="/site/images/campaign/wink-icon.png" alt="emoji" width="20" height="20" /></Paragraph>
          <Field
            name="campaign[smoking_quantity]"
            validate={[required, number]}
            type="text"
            component={renderField}
            parse={parsers.number}
            classes="text-input-field"
            onChange={(e, smokingAmount) => this.setState({ smokingAmount })}
            complicated
            setRef={(input) => { this.input = input; }}
            plusHandler={this.increHandler}
            minusHandler={this.decreHandler}
            inputMode="numeric"
          />
          <Button classes={['color-button red']} label="Next" onClick={handleSubmit} />
        </form>
      </Row>
    );
  }
}

Smoking.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  smokingAmount: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'campaign',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Smoking);



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/Smoking.jsx